<template>
	<div>
		<display-categories
			v-if="!isLoading && currentServiceArea"
			:current-service-area="currentServiceArea"
			:current-service-line="currentServiceLine"
			:service-areas="serviceTaxonomy"
			:platform-category="platformCategory"
			:platform-category-name="platformCategoryName"
      :showDropdownForActionBrowse="showDropdownForActionBrowse"
			@clickSARoute="clickSARoute"
			@clickSLRoute="clickSLRoute"
		></display-categories>
		<display-sub-categories
			v-if="serviceLines && serviceTaxonomy.length != 1"
			:service-lines="serviceLines"
			:current-service-line="currentServiceLine"
			@clickSLRoute="clickSLRoute"
			:platform-category="platformCategory"
		></display-sub-categories>

		<display-services
			:services="currentServiceLine.services"
			:platform-category="platformCategory"
			:service-id="serviceId"
			v-if="!isLoading && currentServiceLine"
		></display-services>
	</div>
</template>

<script>
import DisplayServices from "@/components/service-browser/DisplayServices.vue";
import DisplaySubCategories from "@/components/service-browser/DisplaySubCategories.vue";
import DisplayCategories from "@/components/service-browser/DisplayCategories.vue";

import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
	name: "BrowseServiceTaxonomyService",
	props: {
		platformCategory: String,
		platformCategoryName: String,
		categoryId: String,
		serviceId: String,
	},
  watch: {
    "user.userName": function() {
      this.getServiceTaxonomy()
    }
  },
	components: {
		DisplaySubCategories,
		DisplayServices,
		DisplayCategories,
	},
	data() {
		return {
			selectedServiceLine: undefined,
			selectedServiceArea: undefined,
      showDropdownForActionBrowse: true
		};
	},
	computed: {
		...mapGetters(["serviceTaxonomy", "isLoading","user"]),

		serviceLines() {
			const sa = this.currentServiceArea;
			if (sa) {
				return sa.serviceLines;
			} else {
				return null;
			}
		},
		currentServiceArea() {
			//Compute Service Area based on the following criteria
			//1. If user selected a Service Area or deep linked to Service Area then select it
			//2. If not #1 then pick the first Service area from taxonomy
			//3. if not #1 and #2 then do nothing
			if (this.selectedServiceArea) {
				return this.selectedServiceArea;
			} else if (this.serviceTaxonomy) {
				return this.serviceTaxonomy[0];
			} else {
				return null;
			}
		},
		currentServiceLine() {
			//Compute Service Line based on the following criteria
			//1. If user selected a Service Line or deep linked to Service Line then select it
			//2. If not #1 then pick the selected Service area from and the first line within the service area
			//3. if not #1 and #2 then do nothing
			if (this.selectedServiceLine) {
				return this.selectedServiceLine;
			} else {
				const sa = this.currentServiceArea;
				if (sa) {
					return sa.serviceLines[0];
				} else {
					return null;
				}
			}
		},
	},
	methods: {
		...mapActions(["fetchServiceTaxonomy"]),
    getServiceTaxonomy() {

      this.fetchServiceTaxonomy(this.platformCategory).then(() => {
        if (!this.categoryId) {
          if (this.serviceId) {
            this.prepareDeepLinkedServiceId();
            return;
          } else {
            //This usecase covers root access i.e. /categories so pick the first Service Area
            const platform = this.serviceTaxonomy.find(
                (service) => service.name === this.platformCategoryName
            );
            this.hasSingleServiceAreaAndSingleServiceLine()
            this.clickSARoute(platform);
            return;
          }
        }

        //If CategoryId exists then
        //Find if Service Area
        let serviceArea = this.serviceTaxonomy.find(
            (item) => item.id === this.categoryId
        );
        if (serviceArea) {
          this.clickSARoute(serviceArea);
          return;
        }

        //Here CategoryId could be a Service Line
        this.serviceTaxonomy.forEach((item) => {
          let foundSL = item.serviceLines.find(
              (item) => item.id === this.categoryId
          );

          if (foundSL) {
            this.selectServiceArea(item);
            this.selectServiceLine(foundSL);
          }
        });

        this.hasSingleServiceAreaAndSingleServiceLine()
      });
    },
		clickSLRoute(sl) {
			//This method executes the necessary action to take place when Service line is selected.
			this.selectServiceLine(sl);
		},
		clickSARoute(serviceArea) {
			//This method executes the serviceArea action to take place when Service area is selected.
			this.selectServiceArea(serviceArea);
			let sl = serviceArea.serviceLines[0];
			this.$router.push(`/${this.platformCategory}/categories/${sl.id}`);
			this.clickSLRoute(sl);
		},
		selectServiceArea(sa) {
			this.selectedServiceArea = sa;
			this.trackBrowseActions(this.platformCategory, sa.name);
		},
		selectServiceLine(sl) {
			//This method executes the necessary action to take place when Service line is selected.
			this.selectedServiceLine = sl;
			this.trackBrowseActions(this.platformCategory, sl.name);
		},
		selectService(service) {
			this.trackBrowseActions(this.platformCategory, service.name);
		},
		prepareDeepLinkedServiceId() {
			//Prepare for user accessing this page by serviceId in URL.
			this.serviceTaxonomy.forEach((sa) => {
				sa.serviceLines.forEach((sl) => {
					let foundService = sl.services.find(
						(item) => item.id === this.serviceId
					);

					if (foundService) {
						this.selectServiceArea(sa);
						this.selectServiceLine(sl);
						this.selectService(foundService);
					}
				});
			});
		},
    hasSingleServiceAreaAndSingleServiceLine() {
		const serviceAreas = this.serviceTaxonomy
		if (serviceAreas.length === 1 && serviceAreas[0].serviceLines.length === 1) {
			this.showDropdownForActionBrowse = false
		}
    }
	},
	created() {
    this.getServiceTaxonomy()
	},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/service-browser/BrowseServiceTaxonomyService.vue